<template>
<div class="container">
  <navigation-bar />
  <router-view/>
</div>
</template>

<script>
import NavigationBar from "./components/NavigationBar.vue";
export default {
  components: {
    NavigationBar,
  }
}
</script>

<style lang="scss">
@import "./scss/main.scss";
</style>
